import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { JobService } from 'app/jobService';
import { Router } from '@angular/router';

@Component({
  selector: 'apply-job-section5',
  templateUrl: './apply-job-section5.component.html',
  styleUrls: ['./apply-job-section5.component.scss']
})
export class ApplyJobSection5Component implements OnInit {

  @ViewChild('fileInput') fileInput

  userForm: any;

  fileNameDefault: boolean;
  fileNameLink: boolean;

  showOrHide: boolean;
  bypass: boolean;

  explanationText: string;

  constructor(private formBuilder: FormBuilder, private js: JobService, private router: Router) {
    this.fileNameDefault = true;
    this.fileNameLink = false;
    this.showOrHide = true;
  }

  ngOnInit() {
    this.bypass = false;
    this.userForm = this.formBuilder.group({

    });

    this.js.navigate = 5;

    //Render ข้อความอธิบายการอัด VDO
    this.js.GetExplanationApplyJobAPI().subscribe(
      (explanation) => {
        this.explanationText = explanation;
        //alert(this.explanationText);
    });

    this.RenderFileName();
  }

  Upload() {
    var files: FileList = this.fileInput.nativeElement.files;

    if (files.length === 0) {
      alert("กรุณาเลือกไฟล์ก่อนกดปุ่ม Upload");
      this.RenderFileName();
      return;
    }

    //เช็คกับ server ว่ามีไฟล์ไหม
    this.js.CheckUrlVDO().subscribe(
      (urlVDO) => {
        if (urlVDO == "ไม่พบวิดีโอ") {
          this.showOrHide = false;
        } else {
          //พบอยู่แล้วแจ้งตือนจะทับ
          alert("พบไฟล์ในระบบอยู่แล้ว ระบบจะทำการทเซฟฟับไฟล์เดิมให้")
          this.showOrHide = false;
        }
      },
      (error) => { alert(JSON.stringify(error)) },
      () => {
        this.showOrHide = false;
      }
    );

    //Upload
    this.js.Upload(files[0], "vdo").subscribe((data) => {
      this.js.fileVDO = data;
      this.RenderFileName();
      this.showOrHide = true;
    },
      (error) => { 
        alert(JSON.stringify(error)) 
      },
      () => {
        this.showOrHide = true;
      }
    )
  }

  RenderFileName() {
    if (this.js.fileVDO != "ยังไม่มีไฟล์แนบ") {
      this.fileNameDefault = false;
      this.fileNameLink = true;
    } else {
      this.fileNameDefault = true;
      this.fileNameLink = false;
    }
  }

  GotoApplyjobsection6() {
    if (!this.bypass) {
      alert("กรุณาติ๊กเลือกยอมรับว่าข้อมูลทั้งหมดเป็นความจริง");
      return;
    }

    //เช็คกับ server ว่ามีไฟล์ไหม
    this.js.CheckUrlVDO().subscribe(
      (urlVDO) => {
        if (urlVDO == "ไม่พบวิดีโอ") {
          alert("กรุณาอัพโหลด VDO ให้เรียบร้อยก่อน")
          return;
        } else {
          //ไปหน้าต่อไป
          this.router.navigateByUrl('applyjobsection6');
        }
      },
      (error) => { alert(JSON.stringify(error)) },
      () => {

      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/apply-job-section5/apply-job-section5.component.ts